import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "SitePageListViewContainer"
};
const _hoisted_2 = {
  class: "leftCenter"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "colFlex bothCenter"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "leftCenter"
};
const _hoisted_9 = {
  key: 0,
  src: "https://cdn.waityou.online/736652c6-a95c-f436-1dc5-4b44507142ca.png",
  class: "sqr16 mr6"
};
const _hoisted_10 = {
  key: 1,
  src: "https://cdn.waityou.online/53543ff1-c94a-8357-9be6-3cbdcf9315b9.png",
  class: "sqr16 mr6"
};
const _hoisted_11 = {
  key: 2,
  src: "https://cdn.waityou.online/f20f781c-4f06-dd03-eb6d-645acc31629d.svg",
  class: "sqr16 mr6"
};
const _hoisted_12 = {
  key: 0,
  class: "bothCenter colFlex"
};
const _hoisted_13 = {
  key: 1,
  class: "bothCenter colFlex"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 1,
  class: "light"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [$data.initQuery ? (_openBlock(), _createBlock(_component_BatterTableDataView, {
    key: 0,
    "table-id": 5,
    onOnRowSelectChange: $options.onRowSelectChange,
    "init-query": $data.initQuery,
    ref: "pageList"
  }, {
    beforeTable: _withCtx(() => [$data.batchSelected.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      class: "rightCenter mt12"
    }, {
      default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
        "btn-id": 8,
        "bind-id": $data.batchSelected[0],
        "init-data": {
          pageIds: $data.batchSelected
        },
        onFresh: _cache[0] || (_cache[0] = $event => _ctx.$refs.pageList.fetchData()),
        size: "small",
        btnName: "批量创建副本"
      }, null, 8, ["bind-id", "init-data"])]),
      _: 1
    })) : _createCommentVNode("", true)]),
    title: _withCtx(data => [_createElementVNode("div", _hoisted_2, [data.data.schoolId != null ? (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 0,
      class: "item",
      effect: "dark",
      content: data.data.schoolName,
      placement: "top"
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("img", {
        src: "https://cdn.waityou.online/439a2635-e911-3559-3581-b16eb0f557e0.svg",
        class: "sqr16 mr12"
      }, null, -1)])),
      _: 2
    }, 1032, ["content"])) : _createCommentVNode("", true), _createElementVNode("span", {
      class: "ptr",
      style: {
        "color": "#009FFF"
      },
      onClick: $event => $options.gotoEdit(data.data)
    }, _toDisplayString(data.rowData), 9, _hoisted_3), _createElementVNode("img", {
      src: "https://cdn.waityou.online/2365e64e-2a44-1825-5e8e-bc6f14e27426.svg",
      onClick: $event => $options.previewHtml(data.data),
      class: "ml12 sqr20"
    }, null, 8, _hoisted_4), _createElementVNode("img", {
      src: "https://cdn.waityou.online/f520ba4c-9ab3-942d-fd46-901249e52afb.svg",
      onClick: $event => $options.previewHtmlInSite(data.data),
      class: "ml12 sqr22"
    }, null, 8, _hoisted_5)])]),
    visible: _withCtx(data => [_createVNode(_component_el_switch, {
      modelValue: data.data.visible,
      "onUpdate:modelValue": $event => data.data.visible = $event,
      onChange: e => $options.updateVisible(data.data, e)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
    readCnt: _withCtx(data => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(data.rowData), 1), data.data.hotSearchTag == null ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "ptr sqr ml12",
      onClick: $event => $options.createHotSearch(data.rowId),
      style: {
        "color": "red",
        "width": "40px"
      }
    }, "加热", 8, _hoisted_7)) : _createCommentVNode("", true)])]),
    nav: _withCtx(data => [_createElementVNode("div", _hoisted_8, [data.data.hotSearchTag == 'HOT' ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : _createCommentVNode("", true), data.data.hotSearchTag == 'NEW' ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true), data.data.hotSearchTag == 'NONE' ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(data?.data?.nav?.label) + " / " + _toDisplayString(data?.data?.subNav?.label), 1)])]),
    copySize: _withCtx(data => [data.data.copySourceId == null ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(data.rowData), 1), _createVNode(_component_ButtonDialog, {
      "btn-id": 7,
      style: 1,
      "bind-id": data.rowId,
      "init-data": {
        pageId: data.rowId
      },
      onFresh: _cache[1] || (_cache[1] = $event => _ctx.$refs.pageList.fetchData()),
      size: "small",
      btnName: "创建副本"
    }, null, 8, ["bind-id", "init-data"])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[4] || (_cache[4] = [_createElementVNode("span", null, "-", -1)])))]),
    subNav: _withCtx(data => [data?.data?.subNav ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(data?.data?.subNav?.label), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_15, "无"))]),
    _: 1
  }, 8, ["onOnRowSelectChange", "init-query"])) : _createCommentVNode("", true)]), _createVNode(_component_ButtonDialog, {
    ref: "createHotSearch",
    "btn-id": 9,
    "bind-id": $data.curPageId,
    style: 1,
    "btn-name": "",
    onFresh: _cache[2] || (_cache[2] = $event => _ctx.$refs.pageList.fetchData()),
    "init-data": {
      siteId: $props.site.value,
      pageId: $data.curPageId
    }
  }, null, 8, ["bind-id", "init-data"])], 64);
}